/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   16/11/2022
 */

import {gql} from "urql";
import {SummaryNotification, SummaryNotificationConfig} from "../../interfaces/Global";

export const CreateSummaryNotificationMutation = gql`
    mutation CreateSummaryNotification($data: SummaryNotificationInput!) {
        createSummaryNotification(data: $data) {
            id
            creationDate
            createdBy
            modifiedDate
            modifiedBy
            vstamp
	        properties
            enabled
            config
        }
    }
`;

export const UpdateSummaryNotificationMutation = gql`
    mutation UpdateSummaryNotification($id: Int!, $data: SummaryNotificationInput!) {
        updateSummaryNotification(id: $id, data: $data) {
            id
            creationDate
            createdBy
            modifiedDate
            modifiedBy
            vstamp
            properties
            enabled
            config
        }
    }
`;

export const DeleteSummaryNotificationMutation = gql`
    mutation DeleteSummaryNotification($id: Int!) {
        deleteSummaryNotification(id: $id)
    }
`;

export interface DeleteSummaryNotificationResponse {
	deleteSummaryNotification: boolean
}

export interface DeleteSummaryNotificationVars {
	id: number
}

export interface CreateSummaryNotificationResponse {
	createSummaryNotification: SummaryNotification
}

export interface CreateSummaryNotificationVars {
	data: SummaryNotificationInput
}

export interface UpdateSummaryNotificationResponse {
	updateSummaryNotification: SummaryNotification
}

export interface UpdateSummaryNotificationVars {
	id: number
	data: SummaryNotificationInput
}

export interface SummaryNotificationInput {
	enabled?: boolean
	config?: SummaryNotificationConfig
}